// extracted by mini-css-extract-plugin
module.exports = {"imageHolder":"e_Ih","imageUI":"e_Jh","badgeContainer":"e_Kh","badgeImage":"e_Lh","container":"e_Mh"};